import { Atom } from "AppReact";
import styled from "styled-components";

const template = styled.div`
  margin-left: 10px; 
  margin-bottom: 9px;
` 

export default Atom({ type: 'button', dataType: 'object', template})
